export default __webpack_public_path__ + "static/media/1_0130.0bee2e80.webp";